export default {"src":"/_next/static/media/filter.a51d8184.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};